import React, { useEffect, useState } from 'react';
import { Row, Col } from 'antd';
import { useLocation } from 'react-router-dom';
import { useHeader } from '@app/components/header/layouts/HeaderContext';
import CustomerDetailView from '@app/components/apps/Customers/CustomerDetailView';
import { BaseBreadcrumbWithRender } from '@app/components/common/BaseBreadcrumb/BaseBreadcrumb';

const ViewCustomerPage: React.FC = () => {
  const location = useLocation();
  const { id, verified } = location.state || {};
  const [currentBreadcrumbName, setCurrentBreadcrumbName] = useState<string>('Loading...');
  const { setBreadcrumb, clearHeaderButtons } = useHeader();

  useEffect(() => {
    const basePath = verified === true ? '/verified-customers' : verified === false ? '/new-customers' : '/customers';
    const baseName = verified === true ? 'Verified Customers' : verified === false ? 'New Customers' : 'Customers';

    setBreadcrumb(
      <BaseBreadcrumbWithRender
        routes={[
          {
            path: basePath,
            breadcrumbName: baseName,
          },
          {
            path: '/view-customer',
            breadcrumbName: currentBreadcrumbName,
          },
        ]}
      />,
    );

    return () => {
      setBreadcrumb(undefined);
      clearHeaderButtons();
    };
  }, [verified, currentBreadcrumbName, setBreadcrumb, clearHeaderButtons]);

  return (
    <>
      <Row gutter={[16, 16]}>
        <Col span={24}></Col>
        <Col span={24}>
          <CustomerDetailView mode="view" customerId={id} setCurrentBreadcrumName={setCurrentBreadcrumbName} />
        </Col>
      </Row>
    </>
  );
};

export default ViewCustomerPage;
